import React from "react";

// Borrower-specific forms
import SoloForm from "../forms/BTLForm/SoloForm.jsx";
import PartnershipForm from "../forms/BTLForm/PartnershipForm.jsx";
import LimitedForm from "../forms/BTLForm/LimitedForm.jsx";
import PensionForm from "../forms/BTLForm/PensionForm.jsx";
import IfSoloForm from "../forms/IFForm/SoloForm.jsx";
import IfPartnershipForm from "../forms/IFForm/PartnershipForm.jsx";
import IfLimitedForm from "../forms/IFForm/LimitedForm.jsx";
import IfPensionForm from "../forms/IFForm/PensionForm.jsx";

/**
 * Renders the correct borrower form.
 * NOTE: intentionally no "Step 2: ..." heading here.
 */
export default function StepForm({
  borrowerType, // "individual" | "partnership" | "limited" | "pension"
  productType,
  productId,
  applicationName,   // ✅ NEW (Applications doc name)
  initialPayload,    // ✅ NEW (parsed JSON from application_payload)
  onBack,
  onNext,            // ✅ NEW: Wizard wants onNext separately
  onSubmit,          // called when form completes (legacy)
  isSubmitting = false,
}) {
  const isIf = String(productType || "").toUpperCase() === "IF";
  let Form = null;

  switch (borrowerType) {
    case "individual":
      Form = isIf ? IfSoloForm : SoloForm;
      break;
    case "partnership":
      Form = isIf ? IfPartnershipForm : PartnershipForm;
      break;
    case "limited":
      Form = isIf ? IfLimitedForm : LimitedForm;
      break;
    case "pension":
      Form = isIf ? IfPensionForm : PensionForm;
      break;
    default:
      return (
        <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-amber-800">
          Unknown borrower type: <strong>{String(borrowerType || "")}</strong>
        </div>
      );
  }

  const handleNext = (data) => {
    onNext?.(data);
  };

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 md:p-6 overflow-visible pb-4 min-w-0">
      <Form
        onBack={onBack}
        onNext={handleNext}
        productType={productType}
        productId={productId}
        applicationName={applicationName} // ✅ enables upload + save
        initialPayload={initialPayload}   // ✅ enables prefill
        isSubmitting={isSubmitting}
      />
    </div>
  );
}
